import { Pressable } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      alignItems: 'center',
      width: '100%',
      display: 'flex',
      backgroundColor: theme.colorActionFillEmphasisEnabled,
      borderWidth: theme.borderWidthNone,
      borderColor: theme.colorActionBorderEmphasisEnabled,
      borderRadius: theme.borderRadiusPill,
      paddingLeft: theme.spacingStackThreepulse,
      paddingRight: theme.spacingStackThreepulse,
    },
    variants: {
      orientation: {
        horizontal: {
          minWidth: 96,
          flexDirection: 'row',
          height: theme.sizingLarge,
          paddingLeft: theme.paddingInsetThreepulse,
          paddingTop: theme.paddingInsetThreepulse,
          paddingBottom: theme.paddingInsetThreepulse,
          paddingRight: theme.paddingInsetFourpulse,
          borderRadius: theme.borderRadiusPill,
        },
        vertical: {
          minWidth: 96,
          width: 158,
          height: 108,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: theme.borderRadiusLargecontainer,
          paddingTop: theme.paddingInsetNone,
          paddingBottom: theme.paddingInsetNone,
          paddingLeft: theme.paddingInsetThreepulse,
          paddingRight: theme.paddingInsetThreepulse,
        },
      },
      hasPressed: {
        true: {
          backgroundColor: theme.colorActionFillEmphasisPressed,
          borderColor: theme.colorActionBorderEmphasisPressed,
        },
      },
      hasDisabled: {
        true: {
          backgroundColor: theme.colorActionFillEmphasisDisabled,
          borderColor: theme.colorActionBorderEmphasisDisabled,
        },
      },
    },
  }
})
